import { render } from "./BaseDropdown.vue?vue&type=template&id=536a0a4a&scoped=true"
import script from "./BaseDropdown.vue?vue&type=script&lang=js"
export * from "./BaseDropdown.vue?vue&type=script&lang=js"

import "./BaseDropdown.vue?vue&type=style&index=0&id=536a0a4a&lang=scss&scoped=true"

import exportComponent from "/home/forge/app-ticket.grandigiardini.it/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-536a0a4a"]])

export default __exports__